import { PracticeFunction } from "app/models/practice"

export enum Types {
  GET = "FUNCTIONS_GET",
  GET_SUCCESS = "FUNCTIONS_GET_SUCCESS",
  GET_FAIL = "FUNCTIONS_GET_FAIL",
  PATCH = "FUNCTIONS_PATCH",
  PATCH_SUCCESS = "FUNCTIONS_PATCH_SUCCESS",
  PATCH_FAIL = "FUNCTIONS_PATCH_FAIL",
  PATCH_ORDER = "FUNCTIONS_PATCH_ORDER",
  PATCH_ORDER_SUCCESS = "FUNCTIONS_PATCH_ORDER_SUCCESS",
  PATCH_ORDER_FAIL = "FUNCTIONS_PATCH_ORDER_FAIL",
  POST = "FUNCTIONS_POST",
  POST_SUCCESS = "FUNCTIONS_PATCH_POST",
  POST_FAIL = "FUNCTIONS_POST_FAIL",
}

export type Action =
  | GetFunctionsAction
  | GetFunctionsSuccessAction
  | GetFunctionsFailAction
  | PatchFunctionsAction
  | PatchFunctionsSuccessAction
  | PatchFunctionsFailAction
  | PatchFunctionsOrderAction
  | PatchFunctionsOrderSuccess
  | PatchFunctionsOrderFail
  | PostFunctionsAction
  | PostFunctionsSuccessAction
  | PostFunctionsFailAction

export type GetFunctionsAction = {
  type: Types.GET
}

export type GetFunctionsSuccessAction = {
  payload: { data: PracticeFunction[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetFunctionsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PatchFunctionsAction = {
  type: Types.PATCH
  payload: PracticeFunction
}

export type PatchFunctionsSuccessAction = {
  payload: { data: PracticeFunction }
  type: Types.PATCH_SUCCESS
}

export type PatchFunctionsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_FAIL
}

export type PatchFunctionsOrderAction = {
  type: Types.PATCH_ORDER
  payload: string[]
}

export type PatchFunctionsOrderSuccess = {
  payload: { data: PracticeFunction }
  type: Types.PATCH_ORDER_SUCCESS
}

export type PatchFunctionsOrderFail = {
  payload: { errors: object }
  type: Types.PATCH_ORDER_FAIL
}

export type PostFunctionsAction = {
  type: Types.POST
  payload: Pick<PracticeFunction, "name" | "order">
}

export type PostFunctionsSuccessAction = {
  payload: { data: PracticeFunction }
  type: Types.POST_SUCCESS
}

export type PostFunctionsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export function getFunctions(): GetFunctionsAction {
  return {
    type: Types.GET,
  }
}

export function getFunctionsSuccess(data: PracticeFunction[] | undefined): GetFunctionsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getFunctionsFail(errors: object): GetFunctionsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function patchFunctions(payload: PracticeFunction): PatchFunctionsAction {
  return {
    type: Types.PATCH,
    payload,
  }
}

export function patchFunctionsSuccess(data: PracticeFunction): PatchFunctionsSuccessAction {
  return {
    payload: { data },
    type: Types.PATCH_SUCCESS,
  }
}

export function patchFunctionsFail(errors: object): PatchFunctionsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function patchFunctionsOrder(payload: string[]): PatchFunctionsOrderAction {
  return {
    type: Types.PATCH_ORDER,
    payload,
  }
}

export function patchFunctionsOrderSuccess(data: PracticeFunction): PatchFunctionsOrderSuccess {
  return {
    payload: { data },
    type: Types.PATCH_ORDER_SUCCESS,
  }
}

export function patchFunctionsOrderFail(errors: object): PatchFunctionsOrderFail {
  return {
    payload: { errors },
    type: Types.PATCH_ORDER_FAIL,
  }
}

export function postFunctions(payload: Pick<PracticeFunction, "name" | "order">): PostFunctionsAction {
  return {
    type: Types.POST,
    payload,
  }
}

export function postFunctionsSuccess(data: PracticeFunction): PostFunctionsSuccessAction {
  return {
    payload: { data },
    type: Types.POST_SUCCESS,
  }
}

export function postFunctionsFail(errors: object): PostFunctionsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
